import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core'

import { ICartTrack } from '../../../Interface/track'
import { CartService } from '../../../services/cart.service'
import { CurrencySignType, I18nService } from '../../../services/prod/i18n.service'

@Component({
  selector: 'bmcore-track-section-in-cart',
  templateUrl: './bmcore-track-section-in-cart.component.html',
  styleUrls: ['./bmcore-track-section-in-cart.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class BmcoreTrackSectionInCartComponent implements OnInit {
  @Input() track: ICartTrack
  @Input() parentComponent: 'track-in-cart-popUp' | 'track-item'

  currencySign: CurrencySignType

  constructor(
    private i18nService: I18nService,
    protected cartService: CartService
  ) {}

  ngOnInit(): void {
    this.currencySign = this.i18nService.getCurrencySign()
  }

  changeLicense(e: MouseEvent, beatId: number, licenseId: string) {
    e.stopPropagation()
    this.cartService.wantAddBeat(beatId, licenseId)
  }

  deleteTrackFromCart(beatId: number) {
    this.cartService.removeBeat(beatId)
  }

  checkIsShowEditIcon(track: ICartTrack): boolean {
    if (!track.isOK) {
      return (
        track.message === 'Выбранная лицензия не доступна для данного бита' ||
        track.message === 'Selected license is unavailable for current beat.'
      )
    }
    return true
  }
}
